import {getLegendUrl, updateBookmarkPresentationByID, updateLayerSourceParams} from "@/helpers/ol/ol-layer-helper";
import {getLegendUrlByBookmarkPresentation, updateInfoLegends} from "@/helpers/layer/info/layer-info-legend-helper";

export function initLayerStylePicker(id, bookmarkPresentation) {
    const bookmarkPresentationID = bookmarkPresentation.ID
    const element = document.getElementById(id + '-' + bookmarkPresentationID)

    if(element !== null) {
        element.addEventListener('change', () => {
            updateLayerSourceParams(bookmarkPresentationID, 'STYLES', element.value)
            updateBookmarkPresentationByID(bookmarkPresentationID, 'StyleActive', element.value)
            updateInfoLegends()
            getLegendUrlByBookmarkPresentation(`#collapse-legend${bookmarkPresentation.ID} img`, bookmarkPresentation)
        })
    }
}
